export const backgroundColor = '#6BC294'; // soccer pitch green

export const selectionStyles = {
  borderColor: 'white',
  borderScaleFactor: 1.2,
  cornerColor: 'white',
  cornerSize: 15,
  cornerStyle: 'circle',
};

export const lineControlStyles = {
  radius: 10,
  fill: 'transparent',
  stroke: '#fff',
  strokeWidth: 3,
  opacity: 0.5,
};

// fade length (ms) for the line-control handles on select/deselect
export const lineControlFadeTransitionLength = 200;
